var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.78803 21.5938C5.17803 21.5938 4.60803 21.3838 4.19803 20.9938C3.67803 20.5038 3.42803 19.7638 3.51803 18.9638L3.88803 15.7238C3.95803 15.1138 4.32803 14.3038 4.75803 13.8638L12.968 5.17378C15.018 3.00378 17.158 2.94378 19.328 4.99378C21.498 7.04378 21.558 9.18378 19.508 11.3538L11.298 20.0438C10.878 20.4938 10.098 20.9138 9.48803 21.0138L6.26803 21.5638C6.09803 21.5738 5.94803 21.5938 5.78803 21.5938ZM16.178 4.98378C15.408 4.98378 14.738 5.46378 14.058 6.18378L5.84803 14.8838C5.64803 15.0938 5.41803 15.5938 5.37803 15.8838L5.00803 19.1238C4.96803 19.4538 5.04803 19.7238 5.22803 19.8938C5.40803 20.0638 5.67803 20.1238 6.00803 20.0738L9.22803 19.5238C9.51803 19.4738 9.99803 19.2138 10.198 19.0038L18.408 10.3138C19.648 8.99378 20.098 7.77378 18.288 6.07378C17.488 5.30378 16.798 4.98378 16.178 4.98378Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5885 13.0236C17.5685 13.0236 17.5385 13.0236 17.5185 13.0236C14.3985 12.7136 11.8885 10.3436 11.4085 7.24358C11.3485 6.83358 11.6285 6.45358 12.0385 6.38358C12.4485 6.32358 12.8285 6.60358 12.8985 7.01358C13.2785 9.43358 15.2385 11.2936 17.6785 11.5336C18.0885 11.5736 18.3885 11.9436 18.3485 12.3536C18.2985 12.7336 17.9685 13.0236 17.5885 13.0236Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit-2.2af6832de1baceb0244bea78faaeaaa6.svg";
export { ForwardRef as ReactComponent };